module.exports = __webpack_public_path__ + "static/BBB-Logo-788cf938e690c3e1f725b1284690b601.svg";